import { render, staticRenderFns } from "./RespostaViewBase.vue?vue&type=template&id=1b3b8756&scoped=true"
import script from "./RespostaViewBase.vue?vue&type=script&lang=js"
export * from "./RespostaViewBase.vue?vue&type=script&lang=js"
import style0 from "./RespostaViewBase.vue?vue&type=style&index=0&id=1b3b8756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b8756",
  null
  
)

export default component.exports